import React, { Component } from "react";
import {ToastContainer, ToastStore} from 'react-toasts';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Row, Col, Tabs, Tab, Checkbox, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NewClientForm from '../../components/client/new';
import EditClientForm from '../../components/client/edit';

import Reports from '../../components/reports-list';
import Logos from '../../components/logo-upload';
import Forms from '../../components/forms';
import EventWidget from "../../components/widgets/event-widget";

import UserService from '../../services/users-service';
import FormService from '../../services/forms-service';
import ClientService from '../../services/client-service';
import FormdataService from "../../services/formdata-service";

class Archon extends Component{
	constructor(props){
		super(props);

		this.state = {
			data:[],
			view:'list',
			selected:null,
			branches:[],
			facilities:[],
			clients:[],
			forms:[]
		}

		this.tableOptions = {
			hideSizePerPage:true,
			defaultSortName:'name',
			defaultSortOrder:'asc'
		}

		this.credentials =  UserService.sharedInstance.getStoredCredentials();

		this.getAllFormsByLicense = this.getAllFormsByLicense.bind(this);
		this.getReportsByLicense = this.getReportsByLicense.bind(this);
	}

	componentDidMount(){
		this.loadData();
		this.getAllFormsByLicense();
		this.getFormDataByType('Branch');
		this.getFormDataByType('Client');
		this.getFormDataByType('Facility');
	}

	loadData = () =>{
		const that = this;

		ClientService.sharedInstance.getClients()
			.then(res => {
				if(res.success){
					const {data} = res;

					that.setState({ data  });
				}else{
					alert(res.message);
				}
			}).catch(err => {
				console.error('Error',err);

				alert(err.message);
			});
	}

	renderContent = () =>{
		return (
			<React.Fragment>
				<Row className="widget-top-container">
					<Col md={5} style={{backgroundColor: "white"}}>
						<EventWidget events={this.props.events}/>
					</Col>
				</Row>

				<Row className='main-settings-content'>
					<Col>
						<div className='settings-header'>
							<h2>Archon</h2>
						</div>
						<div className='tab-container'>
							<Tabs id='archon-tabs' defaultActiveKey='clients'>
								<Tab eventKey='clients' title='Client List' className='form-tabs'>
									{this.renderClientList()}
								</Tab>
								<Tab eventKey='new_client' title='New Client' className='form-tabs'>
									{this.renderNewClient()}
								</Tab>
								<Tab eventKey='download' title='Downloads' className='form-tabs'>
									{this.renderDownload()}
								</Tab>
								<Tab eventKey='report' title='Reports' className='form-tabs'>
									<Reports />
								</Tab>
								<Tab eventKey='logo' title='Logos' className='form-tabs'>
									<Logos />
								</Tab>
								<Tab eventKey='forms' title='Forms' className='form-tabs'>
									{this.renderForms()}
								</Tab>
							</Tabs>
						</div>
					</Col>
				</Row>
				<ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
			</React.Fragment>
		)
	}

	getFormDataByType = (dropdown) =>{
		const that = this;
		const type = dropdown.replace(/ /g,'_');

		const credentials = this.credentials;
		const login = credentials.loginResponse;
		const data = login.data[0];
		const {token_data} = login;

		const license = data.User_License;
		const auth_username = data.User_ID;
		const {token} = token_data;

		const param = {
			type,
			token,
			license,
			auth_username
		};

		FormdataService.sharedInstance.getFormDataByType(param)
			.then(response => {
				if(type === 'Branch'){
					that.setState({ branches:response });
				}else if(type === 'Client'){
					that.setState({ clients:response });
				}else if(type === 'Facility'){
					that.setState({ facilities:response });
				}
			}).catch(err => {
				console.error('Error:',err);

				alert(err.message);
			});
	}

	getAllFormsByLicense = () =>{
		const that = this;

		const credentials = this.credentials;
		const login = credentials.loginResponse;
		const data = login.data[0];
		const {token_data} = login;

		const license = data.User_License;
		const auth_username = data.User_ID;
		const {token} = token_data;

		const param = {
			token,
			license,
			auth_username
		};

		FormService.sharedInstance.getAllFormsByLicense(param)
			.then(forms => {
				that.setState({ forms });
			}).catch(err => {
				console.error('Error:',err);

				alert(err.message);
			});
	}

	getReportsByLicense = () =>{

	}

	onDisableClient = (id) =>{
		const that = this;

		ClientService.sharedInstance.disableClient(id)
			.then(res => {
				if(res.success){
					that.loadData();
				}else{
					alert(res.message);
				}
			}).catch(err => {
				console.error('Error',err);

				alert(err.message);
			});
	}

	onLoginClient = (license) =>{
		const that = this;
		const {User_ID, Password, User_License, permission_info} = license;

		UserService.sharedInstance.signInWithCredentials(User_License,User_ID,Password)
			.then(response => {
				if(response.success){

					const permission = permission_info ? JSON.parse(permission_info) : {};
					const keys = Object.keys(permission);
					const defaultPage = keys[0];

					response.permission = permission;

					UserService.sharedInstance.storeLoggedInCredentials(
						response.user_type.recno,
						User_ID,
						User_License,
						response.token_data,
						false,
						Password,
						response
					);

					that.props.pageChange(defaultPage);
				}
			}).catch(err => {
				console.error('Error:',err);

				alert(err.message);
			});
	}

	renderRowLogin = (cell, row, index, extra) =>{
		return (
			<Button className='action-button' onClick={() => this.onLoginClient(row)}>
				Login
			</Button>
		)
	}

	renderRowStatus = (cell, row, index,extra) =>{
		const {id} = row;

		return (
			<Checkbox defaultChecked={true} onChange={() => this.onDisableClient(id)}>Active</Checkbox>
		)
	}

	renderRowEdit = (cell, row ,index, extra) =>{
		return (
			<Button className='action-button' onClick={() => this.onEditClient(row)}>
					<FontAwesomeIcon icon='pencil-alt'/>
			</Button>
		)
	}

	onEditClient = (data) =>{
		this.setState({
			view:'edit',
			selected:data
		});
	}

	onViewClientList = () =>{
		this.setState({selected:null,view:'list'},() => {
			this.loadData();
		});
	}

	renderClientList = () =>{
		const {data,view,selected} = this.state;

		if(view === 'list'){
			return (
				<div style={{padding:20}}>
					<BootstrapTable data={data} hover={true} keyField='id' pagination options={this.tableOptions}>
						<TableHeaderColumn dataField='login' width='100px' dataFormat={this.renderRowLogin}></TableHeaderColumn>
						<TableHeaderColumn dataSort dataField='name' width='200px'>Name</TableHeaderColumn>
						<TableHeaderColumn dataSort dataField='license' width='100px'>License</TableHeaderColumn>
						<TableHeaderColumn dataSort dataField='contact_name' width='150px'>Contact Name</TableHeaderColumn>
						<TableHeaderColumn dataSort dataField='contact_email' width='150px'>Contact Email</TableHeaderColumn>
						<TableHeaderColumn dataSort dataField='contact_phone' width='150px'>Contact Phone</TableHeaderColumn>
						<TableHeaderColumn dataField='status' width='100px' dataFormat={this.renderRowStatus}>Status</TableHeaderColumn>
						<TableHeaderColumn dataField='edit' width='80px' dataFormat={this.renderRowEdit}></TableHeaderColumn>
					</BootstrapTable>
				</div>
			)
		}else if(view === 'edit'){
			return	<EditClientForm
								client={selected}
								notification={ToastStore}
								onReloadData={this.onViewClientList}
							/>
		}

		return null
	}

	renderNewClient = () =>{
		return <NewClientForm
						notification={ToastStore}
						onReloadData={this.loadData}
					/>
	}

	renderDownload = () =>{
		return null;
	}

	renderForms = () =>{
		const {facilities,branches,clients} = this.props;
		const forms = this.state.forms;

		return (
			<Forms
				forms={forms}
				facilities={facilities}
				branches={branches}
				clients={clients}
				getAllFormsByLicense={this.getAllFormsByLicense}
				getReportsByLicense={this.getReportsByLicense}
				updateData={this.props.updateData}
			/>
		)
	}

	render(){
		return (
			<React.Fragment>
				{this.renderContent()}
			</React.Fragment>
		)
	}

}

export default Archon;
